import PeriodicExecuter from "../../helpers/periodic_executer";
import {isEmpty} from "../../helpers/object";

export default class ReviewsReader {

    constructor(props={}) {
        this.sourceId = props.hasOwnProperty('sourceId') ? props.sourceId : null;
        const sourceElement = this.getSourceElement();
        if (!sourceElement) return;

        this.ratingSelector = sourceElement.dataset['reviews_reader__rating_selector'];
        this.starSelector = sourceElement.dataset['reviews_reader__star_selector'];
        this.reviewsCountSelector = sourceElement.dataset['reviews_reader__reviews_count_selector'];
        this.actionsSelector = sourceElement.dataset['reviews_reader__actions_selector'];

        this.data = null;
    }

    // Returns a promise that resolves to our reviews data (eg. { rating: 5, reviewsCount: 3 }
    // Rejects when the data can't be found or after it times out.
    getData(){
        return new Promise((resolve, reject) => {
            if (!this.sourceId) reject("[ReviewsReader] No sourceId provided.");
            let poller = new PeriodicExecuter(()=>{
                this.sourceElement = this.getSourceElement();
                if (!this.sourceElement) reject("[ReviewsReader] No sourceElement found.");
                this.extractData();
                if (this.hasData()) {
                    resolve(this.data);
                    poller.stop();
                }
            }, 1);
            window.setTimeout(()=> {
                poller.stop();
                reject("[ReviewsReader] Reviews data could not be found.")
            }, 3000);
        });
    }

    getSourceElement(){
        if (!this.sourceId) return;
        return document.getElementById(this.sourceId);
    }

    getRatingElement(){
        if (!this.sourceElement) return;
        if (!this.ratingSelector) return;
        return this.sourceElement.querySelector(this.ratingSelector);
    }

    getReviewsCountElement(){
        if (!this.sourceElement) return;
        if (!this.reviewsCountSelector) return;
        return this.sourceElement.querySelector(this.reviewsCountSelector);
    }

    getActionsElement(){
        if (!this.sourceElement) return;
        if (!this.actionsSelector) return;
        return this.sourceElement.querySelector(this.actionsSelector);
    }

    extractData(){
        const rating = this.extractRating();
        const ratingHtml = this.extractRatingHtml();
        const reviewsCountText = this.extractReviewsCountText();
        const reviewsCount = this.extractReviewsCount();
        const actionsHtml = this.extractActionsHtml();
        this.data = {};
        if (!!rating) this.data.rating = rating;
        if (!!ratingHtml) this.data.ratingHtml = ratingHtml;
        if (!!reviewsCountText) this.data.reviewsCountText = reviewsCountText;
        if (!!reviewsCount) this.data.reviewsCount = reviewsCount;
        if (!!actionsHtml) this.data.actionsHtml = actionsHtml;
        console.log("[ReviewsReader] Extracted reviews data:", this.data);
    }

    extractRating() {
        const ratingElement = this.getRatingElement();
        if (!ratingElement) return null;
        const starElements = ratingElement.querySelectorAll(this.starSelector);
        if (!starElements) return null;
        return starElements.length;
    }

    extractRatingHtml() {
        const ratingElement = this.getRatingElement();
        if (!ratingElement) return null;
        return ratingElement.outerHTML;
    }

    extractReviewsCountText() {
        const reviewsCountElement = this.getReviewsCountElement();
        if (!reviewsCountElement) return null;
        const reviewsCountText = reviewsCountElement.textContent;
        const regex = /(\d+\s+(reviews|review))/i;
        const match = reviewsCountText.match(regex);
        return (!!match) ? match[1] : null;
    }

    extractReviewsCount() {
        const reviewsCountText = this.extractReviewsCountText();
        if (!reviewsCountText) return null;
        const regex = /(\d+)\s+(reviews|review)/i;
        const match = reviewsCountText.match(regex);
        const reviewsCount = (!!match) ? match[1] : null;
        return !!reviewsCount ? parseInt(reviewsCount) : null;
    }

    extractActionsHtml() {
        const actionsElement = this.getActionsElement();
        if (!actionsElement) return null;
        return actionsElement.outerHTML;
    }

    hasData(){
        return (typeof this.data !== 'undefined' && this.data !== null && !isEmpty(this.data));
    }

}
